import { ControlledSubstancePolicySearch } from "../types";

export const urls = {
  controlledSubstanceGuidance: () => "/api/client/v1/controlled-substances/guidance/",
  controlledSubstancePolicy: () => "/api/client/v1/controlled-substances/policy/",
};

export const keys = {
  all: () => ["controlled-substances"],
  guidance: () => [...keys.all(), "guidance"],
  policies: () => [...keys.all(), "policies"],
  policyLists: () => [...keys.policies(), "lists"],
  policyList: (search: ControlledSubstancePolicySearch) => [...keys.policyLists(), search],
};
